import { createElement, useId } from "react";
import { iconRegistry } from "./registry.js";
import "./icon.css";

/**
 * Рисует один знак семейства Axon. Без title знак считается декоративным.
 */
export function AxonIcon({ name, size = 24, title, active = false, className = "" }) {
  const titleId = useId();
  const glyph = iconRegistry[name];

  if (!glyph) {
    throw new Error(`Unknown Axon icon: ${name}`);
  }

  return (
    <svg
      className={`axon-icon ${className}`.trim()}
      data-active={active ? "true" : "false"}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="miter"
      role={title ? "img" : undefined}
      aria-labelledby={title ? titleId : undefined}
      aria-hidden={title ? undefined : "true"}
      focusable="false"
    >
      {title ? <title id={titleId}>{title}</title> : null}
      {glyph.map(([element, props], index) => createElement(element, { ...props, key: `${name}-${index}` }))}
    </svg>
  );
}
